export default __webpack_public_path__ + "static/media/gearshift.53301dc2.svg";